export default "__VITE_ASSET__CpaUlTnQ__"